<template>
    <div class="address-detail" v-title="'收货地址'">
        <van-nav-bar fixed left-arrow :border="false" @click-left="$router.go(-1)">
            <template #title>
                <div>收货地址</div>
            </template>
        </van-nav-bar>
        <div class="address-box">
            <div>
                <van-field 
                    v-model="LinkMan" 
                    name="收货人" 
                    label="收货人" 
                    placeholder="请填写收货人姓名" 
                    maxlength="20"
                    input-align="right"
                >
                    <template slot="label">
                        <span class="address-label">收货人<i>*</i></span>
                    </template>
                </van-field>
                <van-field 
                    v-model="HandSet" 
                    name="联系方式" 
                    label="联系方式" 
                    type="number" 
                    placeholder="请填写联系方式"
                    maxlength="11" 
                    input-align="right"
                >
                    <template slot="label">
                        <span class="address-label">联系方式<i>*</i></span>
                    </template>
                </van-field>
                <van-field 
                    v-model="Address" 
                    is-link 
                    readonly 
                    name="所在地" 
                    label="所在地" 
                    placeholder="点击选择省市"
                    @click="showArea = true" 
                    input-align="right"
                >
                    <template slot="label">
                        <span class="address-label">所在地<i>*</i></span>
                    </template>
                </van-field>
                <van-popup 
                    v-model="showArea" 
                    position="bottom"
                >
                    <van-area 
                        :area-list="areaList" 
                        columns-num="2" 
                        @cancel="showArea = false" 
                        @confirm="onConfirmArea"
                    />
                </van-popup>
                <van-field 
                    v-model="DetailAddress" 
                    name="详细地址" 
                    label="详细地址" 
                    placeholder="请填写详细地址" 
                    maxlength="50"
                    input-align="right"
                >
                    <template slot="label">
                        <span class="address-label">详细地址<i>*</i></span>
                    </template>
                </van-field>
            </div>
            <div class="fooler-btn">
                <button @click="confirmAddress">确 定</button>
            </div>
        </div>
    </div>
</template>
<script>
    import {
        AddShippingAddress,    // 提交用户地址
        GetShippingAddress,     //获取用户地址
    } from '@/common/api.js'
    import {
        areaList
    } from '@vant/area-data';
    export default {
        data() {
            return {
                LinkMan: '',        //收货人
                HandSet: '',        //联系方式
                Address: '',        //所在地
                DetailAddress: '',  //详细地址

                showArea: false,
            }
        },
        computed: {
            areaList() {
                return areaList
            }
        },
        created() {
            bridge.register('getTitleInitData', function () {
                return '{"isShowTitleBar":false}'
            });
        },
        mounted(){
            this.getShippingAddress()
        },
        methods:{
            onConfirmArea(value) {
                this.Address = value
                    .filter((item) => !!item)
                    .map((item) => item.name)
                    .join('');
                this.showArea = false;
            },
            // 提交地址
            confirmAddress() {
                var self = this
                let data = {}
                data.LinkMan = this.LinkMan
                data.HandSet = this.HandSet
                data.Address = this.Address
                data.DetailAddress = this.DetailAddress
                data.UserType = 1
                data.UserId = this.$route.query.userId
                var myreg = /^[1][3456789][0-9]{9}$/;
                if (!data.LinkMan) {
                    return this.$toast('收货人不能为空！')
                }
                if (!data.HandSet) {
                    return this.$toast('收货人联系方式不能为空！')
                }
                if (!myreg.test(data.HandSet)) {
                    return this.$toast('收货人联系方式格式不正确')
                }
                if (!data.Address) {
                    return this.$toast('所在地不能为空！')
                }
                if (!data.DetailAddress) {
                    return this.$toast('详细地址不能为空！')
                }
                AddShippingAddress(data).then(res => {
                    if (res.Result != 1) {
                        return this.$toast(res.Message)
                    }
                    self.$toast(res.Message)
                    setTimeout(function () {
                        self.$router.push({
                            path: '/pointsfor',
                            query: {
                                userId: self.$route.query.userId
                            }
                        });
                    }, 2000)
                })
            },
            getShippingAddress(){
                let data = {}
                data.UserId = this.$route.query.userId
                GetShippingAddress(data).then(res=>{
                    if(res.Result == 1) {
                        this.LinkMan = res.Data.LinkMan
                        this.HandSet = res.Data.HandSet
                        this.Address = res.Data.Address
                        this.DetailAddress = res.Data.DetailAddress
                    }
                })
            },
        },
    }
</script>
<style lang="scss">
@import '~@/style/_base.scss';
    .address-detail {
        padding-top: px2rem(148px);
        padding-bottom: px2rem(60px);
        min-height: 100vh;

        .van-nav-bar--fixed {
            top: 0;
            height: px2rem(158px);
            padding-top: px2rem(70px);

            .van-nav-bar__content {
                height: px2rem(88px);
            }

            i,
            div {
                color: #333333;
            }

            i:before {
                color: #333333;
            }
        }
    }
    .address-box {
        position: relative;
        padding-bottom: px2rem(240px);

        h4 {
            font-weight: 500;
            color: #333333;
            text-align: center;
            font-size: px2rem(32px);
            line-height: px2rem(120px);
        }

        .record-list {
            height: px2rem(360px);
            overflow-y: scroll;

            li {
                display: flex;
                justify-content: space-between;
                align-items: center;
                height: px2rem(90px);
                padding: 0 px2rem(30px);
                border-bottom: 1px solid #e5e5e5;
            }
        }

        .fooler-btn {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            padding: px2rem(80px) px2rem(50px);

            button {
                display: block;
                color: #ffffff;
                border-radius: 2px;
                width: 100%;
                height: px2rem(80px);
                background: #f75959;
                font-size: px2rem(28px);
            }
        }

    }

    .address-box {
        .van-cell {
            border-bottom: 1px solid #e5e5e5;

            &::after {
                border-bottom: none;
            }
        }

        .address-label {
            color: #333333;
            font-size: px2rem(28px);

            i {
                padding-left: px2rem(4px);
                color: red;
            }
        }
    }
</style>